module.exports = __webpack_public_path__ + "static/media/tcs_logo.f491e390.png";